// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3ia3C","button_outline":"button_button_outline__37WGW","btn_sm":"button_btn_sm__1R_O-"};